import { Tag } from '@luminovo/design-system';
import * as React from 'react';
import type { JSX } from 'react';

export const FormulaField = React.forwardRef<HTMLHeadingElement, { label: string | JSX.Element }>(({ label }, ref) => {
    return <Tag ref={ref} color="neutral" attention="low" label={label} />;
});
